<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(sumExpenses)="data">
        {{ Number(data.item.sumExpenses).toFixed(2) }}
      </template>
      <template v-slot:cell(ownerCompanyName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.ownerCompanyName)">{{ data.item.ownerCompanyName }}</div>
      </template>
      <template v-slot:cell(zcClassName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.zcClassName)">{{ data.item.zcClassName }}</div>
      </template>
      <template v-slot:cell(zcName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.zcName)">{{ data.item.zcName }}</div>
      </template>
      <template v-slot:cell(subequ)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.subequ)">{{ data.item.subequ }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "hqglLogisticsInboundDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'ownerCompanyName', label: '产权所属公司', width: '120px'},
        {key: 'zcClassName', label: '资产类别', width: '120px'},
        {key: 'zcName', label: '资产名称', width: '120px'},
        {key: 'zcType', label: '品种', width: '120px'},
        {key: 'brand', label: '品牌', width: '120px'},
        {key: 'zcUnit', label: '单位', width: '120px'},
        {key: 'num', label: '入库数量', width: '120px'},
        {key: 'zhibaoQi', label: '质保期', width: '120px'},
        {key: 'subequ', label: '附属设备设施', width: '120px'},
        {key: 'invoiceDate', label: '开票日期', width: '120px'},
        {key: 'sumExpenses', label: '购置金额（元）', width: '120px'},
        {key: 'contractCode', label: '合同编号', width: '120px'},
        {key: 'provideUnit', label: '供货单位', width: '120px'},
        {key: 'madeUnit', label: '生产厂家', width: '120px'},
        {key: 'buyDate', label: '购置日期', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum3(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(4, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
